import React from 'react';
import { User } from "../components/User/User.jsx";

const Login = () => {
  return (
      <>
        <div className="center">
            <User />
        </div>
      </>
  );
}

export default Login;